export const AGENCY_REVALIDATE_SECONDS = 60;
export const AGENCY_PAGE_DESKTOP_CARDS_LIMIT = 5;
export const DEFAULT_DESKTOP_CARDS_LIMIT = 4;
export const AGENCY_FILTER_CATEGORY_ALL_ID = 'all';

export enum AgencyFilterDealTypeEnum {
  lease = 'lease',
  sale = 'sale'
}

export const AGENCY_FILTER_ALL_DEAL_TYPES = [
  AgencyFilterDealTypeEnum.lease,
  AgencyFilterDealTypeEnum.sale
];

export const COMMERCIAL_CATEGORY_SLUGS = new Set([
  'ofisler',
  'torpaq',
  'obyektler',
  'qarajlar'
]);

export const WEB_VIEW_APP_BAR_BASE_HEIGHT = 60;
export const WEB_VIEW_APP_BAR_MIN_TOP_INSET = 15;
export const CURRENT_ITEM_TITLE_HEIGHT = 85;

export const getWebViewAppBarHeight = (topInset = 0) =>
  WEB_VIEW_APP_BAR_BASE_HEIGHT +
  Math.max(topInset, WEB_VIEW_APP_BAR_MIN_TOP_INSET);
